import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Chip = styled.div`
  padding: 5px;
  border: 1px solid grey;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.3s ease;

  background: ${(props) => (props.isActive ? "#F6AE2D" : "transparent")};

  &:hover {
    background: #f6ae2d;
  }
`;

const BotTagLists = ({ botTagsData, onItemClick }) => {
  const [currentBotTagSlug, setCurrentBotTagSlug] = useState("news");
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
        gap: "15px",
        marginTop: "50px",
        width: "100%",
        justifyContent: "center",
        overflowY: "hidden",
        overflowX: "auto",
      }}
    >
      {/* <Chip
          isActive={currentBotTagSlug == "all"}
          onClick={(e) => {
            onItemClick(e, "all");
            setCurrentBotTagSlug("all");
          }}
        >
          <span> All </span>
        </Chip> */}

      {botTagsData?.map((tag) => {
        if (tag.slug == "mybots" || tag.slug == "recent") {
          return;
        } else {
          return (
            <Chip
              isActive={currentBotTagSlug == tag.slug}
              key={tag.id}
              onClick={(e) => {
                onItemClick(e, tag.slug);
                setCurrentBotTagSlug(tag.slug);
              }}
            >
              <span>{tag.title}</span>
            </Chip>
          );
        }
      })}
    </div>
  );
};

export default BotTagLists;
